import { StatsigConfigurations } from '@confluence/statsig-configurations/entry-points/StatsigConfigurations.ts';

const MAX_ERROR_STACK_LENGTH = 100000;
const DEFAULT_STACK_LENGTH = 1000;

interface LoggingConfig {
	selectors?: boolean;
	errors?: boolean;
	stack?: boolean;
	stackLength?: number;
}

export const parseHydrationErrorInfo = ({ componentStack }) => {
	if (!componentStack) {
		return '';
	}

	let loggingConfig: LoggingConfig = {};
	try {
		loggingConfig = JSON.parse(
			StatsigConfigurations.getString('confluence_hydration_error_logging', '{}'),
		);
	} catch (error) {
		// no-op, if an error occurs here, there's really nowhere to submit it
	}

	if (loggingConfig.stack) {
		const errorStackLogLen = loggingConfig.stackLength ?? DEFAULT_STACK_LENGTH;
		const clampedErrorStackLog = Math.min(MAX_ERROR_STACK_LENGTH, errorStackLogLen);
		return componentStack.toString().substring(0, clampedErrorStackLog) ?? '';
	}

	return '';
};
